export const ZIP_CODES_REQUESTED = 'ZIP_CODES_REQUESTED'
export const ZIP_CODES_RECEIVED = 'ZIP_CODES_RECEIVED'
export const CITIES_REQUESTED = 'CITIES_REQUESTED'
export const CITIES_RECEIVED = 'CITIES_RECEIVED'
